export default __webpack_public_path__ + "static/media/fan-icon.08647fd6.png";